// @flow

import { type UserInputValidationError, VALID } from '@tectonics/prs/validation';

export function validateUruguayanAddress(addressValue: string): ?UserInputValidationError {
  return addressValue && addressValue.length > 0 ? VALID : { id: 'empty' };
}
